
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppInput } from '@/components';
import { useActivityDetail } from '@/modules/activity/model/detail';
import { formatDate, renderOption } from '@/common/utils/helpers';
import { TaskOption } from '@/modules/activity/model/mixins';
import { ROUTE_NAME_ACTIVITY } from '@/modules/activity/router';

export default defineComponent({
    name: ROUTE_NAME_ACTIVITY.DETAIL,
    components: { AppCard, AppInput },
    setup() {
        const { model, fetch } = useActivityDetail();

        onMounted(async () => {
            await fetch();
        });

        return { model, formatDate, renderOption, TaskOption };
    }
});
